import {
  bootstrapSession,
  clearSession,
  configureAuthSession,
  getAuthData as _getAuthData,
  getCookie,
  loginRedirect as _loginRedirect,
} from '@alefeducation/auth-session';
import { FEATURE_TOGGLE } from './FeatureToggle';

const ALEF_USER_KEY = 'alef_user';
const SELECTED_ORGANISATION_KEY = 'selectedOrganisation';

const JWT_COOKIE = {
  name: 'jwt',
  path: '/',
};

const JWTC_COOKIE = {
  name: 'jwtc',
  path: '/',
};

configureAuthSession({
  contentDomain: FEATURE_TOGGLE.CONTENT_DOMAIN,
  persistTokenInStorage: false,
  cookies: {
    jwt: JWT_COOKIE.name,
    contentJwt: JWTC_COOKIE.name,
    legacyUserCookie: ALEF_USER_KEY,
    cdnJwt: undefined,
  },
});

export const bootstrapAuthSession = () => bootstrapSession();
export const getAuthData = () => _getAuthData();
export const getAccessToken = () =>
  getCookie(JWT_COOKIE.name) ?? _getAuthData()?.token?.access_token;
export const loginRedirect = () => _loginRedirect('/login');

export const clearAuthSession = () => {
  clearSession();
  localStorage.removeItem(SELECTED_ORGANISATION_KEY);
};
